import * as React from "react"
const SvgImageGallery = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.36 4.914a1.88 1.88 0 0 0-.324 1.487l1.524 8.62a1 1 0 0 0 .4.662.94.94 0 0 0 .75.163q.425-.075.65-.413.224-.337.15-.762l-1.5-8.595 10.819-1.924.175.75q.125.5.462.687t.712.137.65-.35.15-.8l-.175-.774a2.24 2.24 0 0 0-.85-1.287 1.77 1.77 0 0 0-1.449-.337L3.66 4.102q-.825.15-1.3.812m7.982 13.899h8.33a.4.4 0 0 0 .374-.229.37.37 0 0 0-.042-.437l-2.29-3.06a.4.4 0 0 0-.333-.167.4.4 0 0 0-.333.166l-2.166 2.894-1.54-2.06a.4.4 0 0 0-.334-.167.4.4 0 0 0-.333.166l-1.666 2.228a.37.37 0 0 0-.041.437.4.4 0 0 0 .374.23Zm1.25-5.83q.52 0 .885-.364c.365-.364.364-.538.364-.885s-.121-.642-.364-.885a1.2 1.2 0 0 0-.885-.364q-.52 0-.885.364a1.2 1.2 0 0 0-.365.885q0 .52.365.885c.365.365.538.364.885.364" />
    <path
      fillRule="evenodd"
      d="M7.608 7.725q-.6.575-.6 1.4v11.043q0 .825.6 1.4.6.574 1.424.574h10.97q.824 0 1.41-.587.588-.587.588-1.412V9.15q0-.825-.587-1.411A1.93 1.93 0 0 0 20 7.15H9.032q-.825 0-1.424.575M20 20.143V9.15H9.007v10.994z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgImageGallery
